/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef } from "react";
// @material-ui/core components
import { red } from '@material-ui/core/colors';
import axios from 'axios';
import clsx from 'clsx';
import {
    TextField,
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper, TableSortLabel, TableFooter, TablePagination,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
} from '@material-ui/core';

import IconButton from '@material-ui/core/IconButton';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import FirstPageIcon from '@material-ui/icons/FirstPage';
import LastPageIcon from '@material-ui/icons/LastPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';

import Typography from "@material-ui/core/Typography";
import EditIcon from '@material-ui/icons/Edit';
import { makeStyles } from '@material-ui/core/styles';

import {
     Modal, ModalHeader, ModalBody, ModalFooter,
    FormGroup, Label, Input,
    Row,
  InputGroupAddon,
  InputGroupText,
  InputGroup
} from 'reactstrap';

// core components
import Grid from "components/Grid/GridContainer";

import Col from "components/Grid/GridItem";
import Card from "components/Card/Card.js";
import CardContent from "@material-ui/core/CardContent";
import CardActions from '@material-ui/core/CardActions';
import Collapse from '@material-ui/core/Collapse';
import CardHeader from "components/Card/CardHeader.js";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import Button2 from "components/CustomButtons/Button.js";
import { authHeader } from "_helpers";
import TSText from "components/Forms/TSText";
import TSSelect2 from "components/Forms/TSSelect2";
import TSUser from "components/Forms/TSUser"; 
import "react-datetime/css/react-datetime.css"
import "./custom-style.css";
import { color } from "highcharts";

const useStyles = makeStyles((theme) => ({
    cardCategoryWhite: {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0",
      flexGrow: 1,
    },
    cardTitle: {
      textAlign: 'center'
    },
    cardTitleWhite: {
      color: "#FFFFFF",
      marginTop: "0px",
      minHeight: "auto",
      fontWeight: "300",
      // fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
      fontFamily: '"Sarabun", sans-serif',
      marginBottom: "3px",
      textDecoration: "none",
      flexGrow: 1,
    },
    collaps:{
      paddingLeft:'40px', 
      paddingTop:'40px',    
      display: 'flex',
      flexDirection: 'column-reverse',
    },
    expand: {
      transform: 'rotate(0deg)',
      marginLeft: 'auto',
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
      }),
      ...StyleSheet.absoluteFillObject,
      alignSelf: 'flex-end',
      position: 'absolute', // add if dont work with above
    },
    expandOpen: {
      transform: 'rotate(180deg)',
    },
    visible: {
        opacity: 1,
        transition: 'opacity 0.5s ease'
    },
    hidden: {
        opacity: 0,
        transition: 'opacity 0.5s ease'
    },
    avatar: {
      backgroundColor: red[500],
    },
    tableContainer: {
        width: '99.99%',
        overflowX: 'auto', // ทำให้ตารางสามารถเลื่อนในแนวนอนเมื่อกว้างเกินไป
      },
    tableRow: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
    },
    tableCell: {
        padding: '2px',
    },
    modalFullscreen: {
        width: '100%',
        height: '100%',
        margin: 0,
        maxWidth: '100%',
      },
      modalContent: {
        height: '100%',
        borderRadius: 0,
      },
      modalBody: {
        overflowY: 'auto',
      },
      pagination: {
        flexShrink: 0,
        marginLeft: theme.spacing(2.5),
    },
    cardXs: {
        width: 75,
        height: 110,
        paddingTop: 10,
        margin: 2,
        textAlign: 'center',
        margin: "3px",
        transition: "0.3s",
        display: "inline-block",
        boxShadow: "0 8px 40px -12px rgba(0,0,0,0.3)",
        "&:hover": {
            boxShadow: "0 16px 70px -12.125px rgba(0,0,0,0.3)"
        }
    },
    cardSm: {
        width: 180,
        height: 140,
        textAlign: 'center',
        margin: "3px",
        transition: "0.3s",
        display: "inline-block",
        boxShadow: "0 8px 40px -12px rgba(0,0,0,0.3)",
        "&:hover": {
            boxShadow: "0 16px 70px -12.125px rgba(0,0,0,0.3)"
        }
    },
    cardImg1: {
        width: 60, height: 60, borderRadius: 60 / 2, objectFit: 'cover', objectPosition: '100% 0'
    },
    cardImg2: {
        width: 100, height: 100, borderRadius: 100 / 2, objectFit: 'cover', objectPosition: '100% 0'
    },
  }));


const AssetTypeList = (props) => {

    const tableText = 'ประเภทครุภัณฑ์';

    const host = '';//'https://e.trangskin.go.th'; 
    var moment = require('moment');
    require('moment/locale/th');
    const classes = useStyles();

    const [dataList, setDataList] = useState([]);
    const [selectedData, setSelectedData] = useState(null);


    //page & order
    const [orderDirection, setOrderDirection] = useState('desc');
    const [orderBy, setOrderBy] = useState('calYear'); // default column to sort
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(25);

    const [expanded, setExpanded] = React.useState(false);

    const [isEditing, setIsEditing] = useState(false);
    const [editIndex, setEditIndex] = useState(null);

    //const [ArrTMoney, setTMoney] = useState([]); 
    //const [ArrKMoney, setKMoney] = useState([]); 

    const [TypeKey, setTypeKey] = useState(0);

    //const [TMoneyKey, setTMoneyKey] = useState(0);
    //const [KMoneyKey, setKMoneyKey] = useState(0);
    const [Keyword, setKeyword] = useState('');

    const [modalOpen, setModalOpen] = useState(false);
    const [modal, setModal] = useState(false);
    const [modal2, setModal2] = useState(false);
    const [errMsg, setErrMsg] = useState([]);
    const [modalError, setModalError] = useState(false);
    const [icon, setIcon] = useState("far fa-question-circle");
/*
    useEffect(() => {

        //ใช้สำหรับ Bind ข้อมูลใส่ Arr Combobox
        
        axios(host+"/api/v1/asset/assettype")
        .then(
          result => {
                var json = JSON.parse(JSON.stringify(result.data.data).split('"name":').join('"label":').split('"typeKey":').join('"value":'));
                setAssetType(json)
            }, error => { console.log(error); }
        );  
        

    }, []);
*/
    //ใช้สำหรับ Bind ข้อมูลใส่ Arr Combobox Level 2
    /*
    useEffect(() => {
        fetchCatgory(TypeKey);
    }, [TypeKey]);//เมื่อ Combobox Level 1 มีการเปลี่ยนค่า
    */


    //Bind Data หลักของ Table
    useEffect(() => {
        fetchDataList();
    }, [Keyword]); //Bind ใหม่เมื่อ Keyword หรือ ค่าอื่นๆ มีการเปลี่ยน เช่น [Keyword, TypeKey]

 
    const fetchDataList = async () => {
        try {
            const response = await axios.get(host +'/api/v1/asset/assettype?name='+Keyword);
            if (response.data.result == 200) {          
                setDataList(response.data.data);
            }    
            else
                setDataList([]);
        } catch (error) {
            console.error('Error fetching dataList:', error);
            setDataList([]);
        }
    };


    //----------------table function----------------
    //page order
    const handleRequestSort = (property) => {
        const isAsc = orderBy === property && orderDirection === 'asc';
        setOrderDirection(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
      };
    
    const sortedAssets = () => {
        return dataList.sort((a, b) => {
          if (orderDirection === 'asc') {
            return a[orderBy] < b[orderBy] ? -1 : 1;
          }
          return a[orderBy] > b[orderBy] ? -1 : 1;
        });
    };
    
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };
    
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    //----------------table function----------------

    //เมื่อปิด Modal
    const handleCloseModal = () => {
        setModalOpen(false);
        setSelectedData(null);

        setIsEditing(false);
        setEditIndex(null);
    };



    //กดเพื่อแก้ไขข้อมูลเดิม  Edit Asset Click
    const handleEdit = (index, _data) => {
        console.log(_data);
        const dataToEdit = _data;
        setEditIndex(index);
        setIsEditing(true);

        setSelectedData(dataToEdit);

        setModalOpen(true);


        //fetchCatgory2(dataToEdit.typeKey); //active combobox level2 ใน modal

        //ใช้สำหรับ TSUser
        /*
        var _rEmployee = [];
        setEmployee(_rEmployee);

        setModalOpen(true);

        if (assetToEdit.userView !== null) {
            _rEmployee.push(assetToEdit.userView);
            setEmployee(_rEmployee)
            setExpanded(false)
        }
        else {
            setExpanded(true)
        }
        */
    };

    //กดเพื่อเพิ่มข้อมูลใหม่ Insert Asset Button Click
    const handleAdd = () => {
        clearForm();
        setModalOpen(true);
    };

    //Clear form input
    const clearForm = () => {
        var nullData = {
            code: null,
            name: null,  
        }

        setSelectedData(nullData);
    };

    //on value change
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setSelectedData({ ...selectedData, [name]: value });
    };
    //on selected change
    const handleSelectChange = (name, value) => {
        setSelectedData({ ...selectedData, [name]: value });
    };

    //เมื่อเลือกเจ้าหน้าที่
    /*
    const handleEmployeeChange = (_val) => {

        setToggleEdit(false);
        setEmployee(_val)

        setSelectedData({ ...selectedData, ["userCode"]: _val[0].userName });

        setExpanded(false);
    }
    */

    const handleSaveChanges = async () => {
        try {
            console.log('/api/v1/asset/assettype/' + selectedData.typeKey)

            console.log(selectedData)
            if (isEditing) {
                await axios.put(host + '/api/v1/asset/assettype/' + selectedData.typeKey, selectedData);
            }
            else {
                await axios.post(host + '/api/v1/asset/assettype/', selectedData);
            }

            handleCloseModal();
            setIsEditing(false);
            setEditIndex(null);

            // Refresh the asset list after updating
            const response = await axios.get(host + '/api/v1/asset/assettype?name=' + Keyword);
            setDataList(response.data.data);

        } catch (error) {
            console.error("Error updating data:", error);
        }
    };

    return (
        <div>
            <Grid>
                <Col xs={12} sm={12} md={12}>
                    <Card>
                        <CardHeader color="primary">

                            <h4 className={classes.cardTitleWhite}>รายการ{tableText}</h4>
                            <p className={classes.cardCategoryWhite}></p>

                        </CardHeader>
                        <CardBody>
                           
                            <div>
                                <Grid>
                                    <Col xs={12} sm={12} md={12}>
                                        <TSText icon="far fa-edit" label="คำค้นหา" value={Keyword} onChange={e => setKeyword(e.target.value)} />
                                    </Col> 
                                    {/* //Combobox Filter
                                   <Col xs={12} sm={12} md={6}>
                                        <TSSelect2 isClearable={true} label="TypeKey" options={ArrAssetType} value={TypeKey} onChange={e => setTypeKey(e != null ? e.value : '') } />
                                    </Col> 
                                    */}

                                </Grid>
                                
                                {/* Add more fields as necessary for other properties */}
                                <Col xs={12} sm={12} md={12} style={{textAlign:'right'}}>
                                    
                                    <Button2
                                        color="success"
                                        type="button"
                                        onClick={handleAdd}
                                    >
                                        <h4><i className={"fa fa-plus"}> เพิ่ม{tableText}</i></h4>
                                    </Button2>

                                </Col>
                                <TableContainer component={Paper} className={classes.tableContainer}>
                                    <Table className={classes.table} aria-label="data table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>
                                                    <TableSortLabel
                                                        active={orderBy === 'code'}
                                                        direction={orderBy === 'code' ? orderDirection : 'asc'}
                                                        onClick={() => handleRequestSort('code')}
                                                    >   
                                                        รหัส{tableText}     
                                                    </TableSortLabel>
                                                </TableCell>
                                                <TableCell>
                                                    <TableSortLabel
                                                        active={orderBy === 'name'}
                                                        direction={orderBy === 'name' ? orderDirection : 'asc'}
                                                        onClick={() => handleRequestSort('name')}
                                                    >   
                                                        ชื่อ{tableText}         
                                                    </TableSortLabel>
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {//dataList.map((asset, index) => (
                                            sortedAssets()
                                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                .map((data, index) => (
                                                <TableRow key={index} className={classes.tableRow}>
                                                        <TableCell className={classes.tableCell}><Button style={{ textDecoration: 'underline' }} onClick={() => handleEdit(index, data)}>{data.code}</Button></TableCell>
                                                        <TableCell className={classes.tableCell}><Button style={{ textDecoration: 'underline' }} onClick={() => handleEdit(index, data)}>{data.name}</Button></TableCell>
                                                        {/*<TableCell className={classes.tableCell} style={{ color: (data.assetStatusKey != null && ArrAssetStatus.find(t => t.value == data.assetStatusKey) != null) ? ArrAssetStatus.find(t => t.value == data.assetStatusKey).color : 'black' }} >{(data.assetStatusKey != null && ArrAssetStatus.find(t => t.value == data.assetStatusKey) != null) ? ArrAssetStatus.find(t => t.value == data.assetStatusKey).label : ''}</TableCell>*/}
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                        <TableFooter>
                                        <TableRow>
                                            <TablePagination
                                            rowsPerPageOptions={[5, 10, 25]}
                                            count={dataList.length}
                                            rowsPerPage={rowsPerPage}
                                            page={page}
                                            onPageChange={handleChangePage}
                                            onRowsPerPageChange={handleChangeRowsPerPage}
                                            />
                                        </TableRow>
                                        </TableFooter>
                                    </Table>
                                </TableContainer>
                            </div>

                        </CardBody>
                        <CardFooter>
                            
                            <Modal isOpen={modalOpen} toggle={handleCloseModal}>
                                <ModalHeader toggle={handleCloseModal}></ModalHeader>
                                <ModalBody>
                                {selectedData && (
                                    <Card>
                                        {(isEditing) ?
                                        <CardHeader color="primary">

                                            <h4 className={classes.cardTitleWhite}>{selectedData.name}</h4>
                                            <p className={classes.cardCategoryWhite}>{selectedData.docNo}</p>

                                        </CardHeader>
                                        : 
                                        <CardHeader color="primary">
                                            <h4 className={classes.cardTitleWhite}>เพิ่ม{tableText}</h4>
                                            <p className={classes.cardCategoryWhite}></p>
                                        </CardHeader>
                                        }
                                        <CardBody>
                                            <Grid>

                            
                                                <Col xs={12} sm={12} md={12}>
                                                    <TSText icon="far fa-edit" name="code" label={"รหัส" + tableText} value={selectedData.code} onChange={e => handleInputChange(e)} />
                                                </Col>
                                                <Col xs={12} sm={12} md={12}>
                                                    <TSText icon="far fa-edit" name="name" label={"ชื่อ"+tableText} value={selectedData.name} onChange={e => handleInputChange(e)} />
                                                </Col>
                                                            
                                                {/* //Input Combobox
                                                <Col xs={12} sm={6} md={6}>
                                                    <TSSelect2 name="typeKey" label="ประเภทครุภัณฑ์" options={ArrAssetType} value={selectedData.typeKey ?? ''} onChange={e => handleSelectChange('typeKey', (e != null ? e.value : '')) } />
                                                </Col>
                                                */}

                                                <Col xs={12} sm={12} md={12} style={{marginTop:'20px'}}>
                                                    <Label>ผู้บันทึก: {selectedData.creatorCode} {selectedData.createDatetime}</Label>
                                                </Col>
                                                <Col xs={12} sm={12} md={12}>
                                                    <Label>แก้ไขล่าสุด: {selectedData.lastEditerCode} {selectedData.lastEditDatetime}</Label>
                                                </Col>

                                            </Grid>
                                      
                                        </CardBody>
                                        <CardFooter>

                                        </CardFooter>
                                    </Card>
                                )}
                                </ModalBody>
                                <div className="modal-footer">
                                    <Button2
                                        color="info"
                                        type="button"
                                        onClick={handleSaveChanges}
                                        style={{marginRight:'50px'}}
                                    >
                                        <h4>บันทึก</h4>
                                    </Button2>

                                    <Button2
                                        color="danger"
                                        type="button"
                                        onClick={handleCloseModal}
                                    >
                                        <h4>ยกเลิก</h4>
                                    </Button2>

                                </div>
                            </Modal>


                            {/* Confirm */}
                            <Modal toggle={() => setModal(false)} isOpen={modal}>
                                <div className="modal-header justify-content-center">
                                    <div>
                                        <i
                                            className={icon}
                                            style={{ color: "blue", fontSize: "2em" }}
                                        ></i>
                                    </div>
                                </div>
                                <ModalBody>
                                    <p
                                        style={{
                                            textAlign: "center", fontSize: "1.8em"
                                        }}
                                    >
                                        {icon !== "fa fa-spinner fa-w-16 fa-spin fa-lg"
                                            ? "ยืนยันการบันทึกข้อมูล"
                                            : "กำลังตรวจสอบข้อมูล"}
                                    </p>
                                    <p> </p>
                                </ModalBody>
                                <div className="modal-footer">

                                    <Button
                                        color="success"
                                        type="button"
                                        //onClick={handleConfirm}
                                        disabled={icon === "fa fa-spinner fa-w-16 fa-spin fa-lg"}
                                    >
                                        <i className={"fa fa-thumbs-up"} style={{ fontSize: "1.8em", padding: "0 5px 5px 0" }}></i>
                                        <h4>ยืนยัน</h4>
                                    </Button>

                                    <Button
                                        color="danger"
                                        type="button"
                                        onClick={() => { setIcon("far fa-question-circle"); setModal(false); }}
                                    >
                                        <i className={"fa fa-thumbs-down"} style={{ fontSize: "1.8em", padding: "0 5px 5px 0" }}></i>
                                        <h4>ยกเลิก</h4>
                                    </Button>


                                </div>
                            </Modal>

                        </CardFooter>
                    </Card>
                </Col>
            </Grid>
        </div>
    );
}



export default AssetTypeList;